import { MDBContainer, MDBRow } from 'mdb-react-ui-kit'

import { AboutUsBanner } from './AboutUsBanner/AboutUsBanner'
import { AboutUsContent } from './AboutUsContent/AboutUsContent'
import React from 'react'

export function AboutUs() {

    return (
        <>
            <MDBContainer className={'border border-0 border-danger'}>
                <MDBRow className={'border border-0 border-success mb-5'}>
                    <AboutUsBanner />
                </MDBRow>
                    <MDBRow className={'border border-0 border-success'}>
                        <AboutUsContent />
                    </MDBRow>
            </MDBContainer>
        </>
    )
}